// Import React to provide to createComponent
import * as React from 'react';

// Import element class to provide to createComponent
import { DxoUiHeader } from '@cof/dxo-ui-header';
// Import createComponent to call and create/export React wrapper below
import { createComponent } from '@lit-labs/react';
import { AuthenticatedUser } from 'src/utils/AuthenticatedUser';
import './DxoUiHeader.css';

// Export React wrapper for dxo-ui-header component
export default createComponent({
  tagName: 'dxo-ui-header',
  elementClass: DxoUiHeader,
  react: React,
});

const solutionsTab = {
  "tabText": "Solutions",
  "tabLink": "/partnerships",
};

const salesPracticeTab = {
  "tabText": "Sales Practice",
  "tabLink": "/partnerships/sales-practice/",
}

const analyticsTab = {
  "tabText": "Analytics",
  "tabLink": "/partnerships/analytics/",
};

const certificationsTab = {
  "tabText": "Certifications",
  "tabLink": "/partnerships/certifications",
};

const testingTab = {
  "tabText": "Testing",
  "tabLink": "/partnerships/testing",
};

// Returns the header tabs the user has access to, in order:
// Solutions, Sales Practice, Analytics, Certifications, Testing
//  Tabs only shown if user has 2+ links.
export const getHeaderTabs = (user?: AuthenticatedUser | null) => {
  const tabs = [];
  if (user?.hasSolutionsRole()) {
    tabs.push(solutionsTab);
  }
  if (user?.hasSalesPracticeRole()) {
    tabs.push(salesPracticeTab);
  }
  if (user?.hasAnalyticsRole()) {
    tabs.push(analyticsTab);
  }
  if (user?.hasCertificationsRole()) {
    tabs.push(certificationsTab);
  }
  if (user?.hasRedpenRole()) {
    tabs.push(testingTab);
  }
  return (tabs.length > 1) ? tabs : [];
};
